export default "__VITE_ASSET__1yBGoQpI__"